import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const MainNavigation = () => {
  const { t, i18n } = useTranslation();
  const languageDirection = i18n.language === "ar" ? "rtl" : "ltr";

  return (
    <div
      className="rbt-main-navigation d-none d-xl-block"
      // dir={languageDirection}
      style={{
        width: "100%",
      }}
    >
      <nav
        className="mainmenu-nav"
        style={{
          width: "100%",
        }}
      >
        <ul
          className="mainmenu"
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent:
              languageDirection === "rtl" ? "flex-start" : "flex-end",
            paddingRight: languageDirection === "rtl" ? "0" : "40px",
            paddingLeft: languageDirection === "rtl" ? "40px" : "0",
            margin: 0,
          }}
        >
          {/* الرئيسية */}
          <li>
            <Link to="/">{t("MainNavigation.title.home")}</Link>
          </li>

          {/* المتحدثون */}
          <li>
            <Link to="/speakers">
              {t("MainNavigation.submenu.speakersGuide")}
            </Link>
          </li>
          
          {/* المؤتمرات */}
          <li>
            <Link to="/events">{t("MainNavigation.title.events")}</Link>
          </li>

          {/* المقالات */}
          <li>
            <Link to="/blog">{t("MainNavigation.title.articles")}</Link>
          </li>
          

          {/* تواصل معنا */}
          <li>
            <Link to="/contact-us">
              {t("MainNavigation.submenu.contactUs")}
            </Link>
          </li>

          {/* من نحن */}
          <li className="has-dropdown has-menu-child-item">
            <Link
              to="/about-us"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                flexDirection:
                  languageDirection === "rtl" ? "row-reverse" : "row",
              }}
            >
              {t("MainNavigation.title.aboutUs")}
              <FontAwesomeIcon icon={faChevronDown} />
            </Link>
            <ul
              className="submenu"
              style={{
                left: languageDirection === "rtl" ? "auto" : "0",
                right: languageDirection === "rtl" ? "0" : "auto",
              }}
            >
              <li>
                <Link to="#"
                  onClick={() => window.open("/about-us", "_blank")}
                >{t("MainNavigation.submenu.aboutSite")}</Link>
              </li>
              <li>
                <Link to="/faq">{t("MainNavigation.submenu.faq")}</Link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>

      <style data-styled="true">{`
        .mainmenu {
          direction: ${languageDirection};
        }

        .mainmenu li {
          margin: ${languageDirection === "rtl" ? "0 0 0 20px" : "0 20px 0 0"};
        }

        .submenu {
          text-align: ${languageDirection === "rtl" ? "right" : "left"};
        }

        .has-dropdown .submenu::before {
          left: ${languageDirection === "rtl" ? "auto" : "20px"};
          right: ${languageDirection === "rtl" ? "20px" : "auto"};
        }
      `}</style>
    </div>
  );
};

export default MainNavigation;
